import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector, RootStateOrAny } from 'react-redux';
import { apiGeneral } from 'services/api';
import { AuthState } from 'store/ducks/auth';

export const GlobalLogger: React.FC = () => {
  const location = useLocation();
  const { data: user } = useSelector<RootStateOrAny>(
    (state) => state?.auth
  ) as AuthState;
  const hostname = window.location.hostname;

  useEffect(() => {
    if (!user) return;
    if (hostname !== 'bayer.webcol.systems') return;

    // Log do acesso à rota
    const logData = {
      general_user_id: user?.user_id,
      general_module_id: process.env.REACT_APP_MODULE_ID,
      route: location.pathname,
      accessed_at: new Date().toISOString(),
    };

    // Persistir log no banco de dados
    apiGeneral.post('/access-log', logData).catch((error) => {
      console.error('[Access Log] Erro ao salvar log:', error);
    });

  }, [location.pathname, user, hostname]);

  return null;
};
